<template>
  <tabs @TabChange="onTabChange" centered position="bottom" type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-nav-classes="icon-white" tab-content-classes="tab-content-padding tab-no-space" style="height: calc(100vh - 100.667px);">
    <!-- Patient History -->
    <tab-pane label="patient-history">
      <template slot="label">
        <i class="fa fa-user" />
      </template>

      <tabs type="primary" @TabChange="patientHistoryTabChange" centered class="patient-history-tabs" tab-nav-wrapper-classes="p-0" tab-content-classes="patient-history-tab-content tab-no-space">
        <!-- Bio -->
        <tab-pane label="Bio" v-if="patient">
          <template slot="label">
            <span>{{ $t("message.Bio") }}</span>
          </template>
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <img :src="require('@/assets/img/proAvatar.png')" alt="avatar" style="width: 100px; height: 100px; border-radius: 50%" v-if="!patient.profileImage" class="avatar border-gray" />
                <profile-image :file-id="patient.profileImage" v-else image-style="width: 100px; height: 100px; border-radius: 50%; margin: auto;">
                </profile-image>
              </div>
              <div class="col-12 text-center mt-3">
                {{ patient.patientId }}
                <h6 class="mt-2">
                  {{ patient.firstName }} {{ patient.lastName }}
                </h6>
                {{ getAge(patient.dob) }}
                <br />
                <div style="font-size: 30px">
                  <span v-if="patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                    <i class="fa fa-mars"></i>
                  </span>
                  <span v-if="patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                    <i class="fa fa-venus"></i>
                  </span>
                  <span v-if="patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                    <i class="fa fa-transgender-alt"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>

        <!-- Vitals history -->
        <tab-pane label="Vitals">
          <template slot="label">
            <div @click="getVitalHistory()">
              <span>{{ $t("message.Vitals") }}</span>
            </div>
          </template>
          <div class="col-12" style="height: 100%;">
            <div v-if="deviceProfile.length > 0" class="row" style="height: 100%; overflow: scroll">
              <div class="col-md-6 col-lg-4" v-for="(device, index) in deviceProfile" :key="device.identifier" :id="device.identifier">
                <vital-card :deviceforcard="device" :vitals="device.vitals" :vital-index="index" ref="vitalComponents" @vital-validated="
                  vitalBtnDisabled = true & shareVitals()
                " :historic-vitals="historicVitals" :error-messages="errorMessages" :allowManualEntry="false" :allowRetrieval="false"></vital-card>
              </div>
            </div>
            <div v-else style="width: 100%; text-align: center;">
              <vitals-not-configured-svg style="height: 39vh; width: 63vw;"></vitals-not-configured-svg>
              <div>
                <i>{{ $t("message.No vitals shared during the appointment") }}</i>
              </div>
            </div>
          </div>
        </tab-pane>

        <!-- Files history -->
        <tab-pane label="Files">
          <template slot="label">
            <span>{{ $t("message.Files") }}</span>
          </template>
          <div class="col-12" style="height: 80vh; overflow:auto">
            <div class="col-12 mt-5 text-center" v-if="!historicFiles || historicFiles.length < 1">
              {{ $t('message.No files for the patient') }}
            </div>
            <div class="col-12 file-list" v-for="(file, index) in historicFiles" :key="index">
              <div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-2 col-md-2 col-lg-2" @click="viewFile(file)">
                      <div v-if="file.type.indexOf('image') > -1">
                        <dynamic-image :file-id="file.fileId" image-style="min-height: 20px; width: 100%">
                        </dynamic-image>
                      </div>
                      <div v-else-if="file.type.indexOf('pdf') > -1" style="text-align: center; font-size: xx-large;">
                        <i class="fa fa-file-pdf" style="font-size: 2em; color: #208fdc"></i>
                      </div>
                      <div v-else-if="file.type.indexOf('video') > -1" style="text-align: center; font-size: xx-large;">
                        <i class="fa fa-file-video" style="font-size: 2em; color: #208fdc"></i>
                      </div>
                      <div v-else-if="file.type.indexOf('audio') > -1" style="text-align: center; font-size: xx-large;">
                        <i class="fa fa-file-audio" style="font-size: 2em; color: #208fdc"></i>
                      </div>
                      <div v-else style="text-align: center; font-size: xx-large;">
                        <i class="fa fa-file" style="font-size: 2em; color: #208fdc"></i>
                      </div>
                    </div>
                    <div class="col-8 col-md-8 col-lg-8" @click="viewFile(file)">
                      <p class="card-heading">{{ file.name }}</p>
                      <p class="card-heading file-date">
                        {{ getFormattedDate(file.created) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <infinite-loading spinner="waveDots" @infinite="getFilesHistory" identifier="activeTab">
              <span slot="no-more">{{ $t("message.No more files") }}</span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>
        </tab-pane>

        <!-- Prescription history -->
        <tab-pane label="Notes">
          <template slot="label">
            <span>{{ $t("message.Notes") }}</span>
          </template>
          <div class="col-12" style="height: 100%;" v-loading="DOWNLOADING_PRESCRIPTION" :element-loading-text="$t('message.Getting your prescription')">
            <div v-if="historicPrescriptions" style="height: 100%;">

              <div class="row h-100">
                <div class="col-12 col-lg-3 h-100" v-if="!selectedPrescription">
                  <!-- List for extra small devices -->
                  <div class="row d-block d-md-block h-100" style="overflow-y:scroll;">
                    <div class="col-12 prescription-list" v-for="prescription in historicPrescriptions" :key="prescription._id">
                      <div @click="viewPrescription(prescription)">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-2 col-md-1 col-lg-3">
                              <i class="el-icon-tickets prescription-icon"></i>
                            </div>
                            <div class="col-10 col-md-11 col-lg-9">
                              <p class="card-heading reason">
                                {{ prescription.reason }}
                              </p>
                              <p class="card-heading mb-0">
                                {{ $t("message.Dr") }}.
                                {{ prescription.provider.firstName }}
                                {{ prescription.provider.lastName }}
                              </p>
                              <p class="card-heading">
                                {{
                                  getFormattedDate(prescription.created)
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="historicPrescriptions.length < 1" class="col-12 text-center">
                      <i class="fa fa-info-circle"></i>
                      {{ $t("message.No Prescriptions available") }}
                    </div>
                  </div>
                </div>

                <div class="h-100" v-if="selectedPrescription">
                  <n-button type="primary" round @click.native="selectedPrescription = null" icon style="position: absolute;z-index: 1;background: transparent;color:black;font-weight: bold;font-size: large;">
                    <i class="now-ui-icons arrows-1_minimal-left"></i>
                  </n-button>
                  <div style="position: absolute;bottom:0;z-index:1;width:100%;text-align:center;">
                    <n-button type="primary" round @click.native="downloadPrescription(selectedPrescription.prescriptions[0].prescriptions, selectedPrescription.prescriptions[0].created)" v-if="HAS_PRESCRIPTION">
                      <i class="fa fa-print"></i>
                      {{ $t("message.Download Prescription") }}
                    </n-button>
                  </div>

                  <card style="height:100%; overflow-y: scroll;">
                    <prescription :prescription="selectedPrescription.prescriptions[0]
                      .prescriptions
                    " v-if="selectedPrescription.prescriptions[0]
  .prescriptions
" :appointment="selectedPrescription" :editable="false"></prescription>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>
      </tabs>
    </tab-pane>

    <!-- Chat messages -->
    <tab-pane label="chat-message" style="padding-top:0px">
      <template slot="label">
        <i class="fas fa-comment-alt" />
      </template>

      <div v-if="appointment" style="position: relative; height:0em; z-index: 1;">
        <div>
          <card>
            <div class="row">
              <div class="col-1">
                <i class="fas fa-user pr-3" style="line-height: 35px; font-size: 1.5em"></i>
              </div>
              <div class="col-11" style="display: grid;align-items: center;">
                <span>
                  {{ `${appointment.patient.firstName} ${appointment.patient.lastName},` }}
                  <small>{{ getAgeYears(appointment.patient.dob) }}</small>
                </span>
              </div>
            </div>
          </card>
        </div>
      </div>

      <beautiful-chat :participants="participants" :titleImageUrl="titleImageUrl" :onMessageWasSent="onMessageWasSent" :messageList="messageList" :newMessagesCount="newMessagesCount" :isOpen="true" :close="closeChat" :open="openChat" :showEmoji="true" :showFile="true" :showTypingIndicator="''" :colors="colors" :alwaysScrollToBottom="true" :messageStyling="true" :showHeader="false" @download-file="viewFile">

        <!-- User avatar-->
        <template v-slot:user-avatar="{ message }">
          <div style="border-radius:50%; font-size: 15px; line-height:25px; text-align:center;background: white; width: 25px !important; height: 25px !important; min-width: 30px;min-height: 30px;margin: 5px; font-weight:bold" v-if="message.author != 'me' && (message.data && message.type != 'system') && message.author != 'carenation-bot'">
            <img :src="messageAvatar(message.author)" alt="" style="border-radius: 50%; width: 100%; height: 100%;">
          </div>
          <div style="border-radius:50%; font-size: 15px; line-height:25px; text-align:center; width: 25px !important; height: 25px !important; min-width: 30px;min-height: 30px;margin: 5px; font-weight:bold; overflow: hidden;" v-if="message.author != 'me' && (message.data && message.type != 'system') && message.author == 'carenation-bot'">
            <img :src="carenationBotImage" alt="" style="padding: 5px; width: 100%; height: 100%; background-color: gray;">
          </div>
        </template>

        <!-- Message body-->
        <template v-slot:text-message-body="{ message }">
          {{ message.data.text }}<br />
          <small v-if="message.data.meta" style="font-size: 60%; font-weight: 200; font-style: italic;">
            {{ message.data.meta }}
          </small>
        </template>

        <!-- System message-->
        <template v-slot:system-message-body="{ message }">
          <span class="fa-stack fa-2x" v-if="message.meta && message.meta.icon && message.meta.icon != 'fas fa-video-slash' && message.meta.icon != 'fas fa-phone-alt'" style="font-size: 0.5em; margin-right: 1em;">
            <i class="fas fa-video fa-stack-2x"></i>
            <i :class="message.meta.icon + ' fa-stack-1x fa-inverse'" style="transform: rotate(45deg); left: -15%;" v-if="message.meta.icon == 'fas fa-arrow-up' || message.meta.icon == 'fas fa-arrow-down'"> </i>
            <i :class="message.meta.icon + ' fa-stack-1x fa-inverse'" v-else style="left: 10%;"> </i>
          </span>
          <span v-if="message.meta && message.meta.icon && message.meta.icon == 'fas fa-video-slash'" style="font-size: 0.5em; margin-right: 1em;">
            <i :class="message.meta.icon" style="font-size: 1.8em;"> </i>
          </span>
          <span v-if="message.meta && message.meta.icon && message.meta.icon == 'fas fa-phone-alt'" style="font-size: 0.5em; margin-right: 1em;">
            <i :class="message.meta.icon" style="font-size: 1.8em;"> </i>
          </span>
          <span v-if="!message.meta.icon" style="font-size: 0.5em; margin-right: 1em;">
            <i class="fas fa-info-circle" style="font-size: 1.8em;"></i>
          </span><span>{{ message.text }}</span>
          <div v-if="message.meta.time" style="font-size: 0.8em; font-style: italic; padding-top: 0.4em;">{{ message.meta.time }}</div>
          <div v-if="message.meta && !message.meta.time" style="font-size: 0.8em; font-style: italic; padding-top: 0.4em;">{{ message.meta }}</div>
        </template>

        <!-- File message body-->
        <template v-slot:file-message-body="{ message }">
          <div v-if="message.file.type == 'application/pdf' || message.file.type == 'prescription'">
            <div class="sc-message--file-icon" style="display: inline;">
              <i v-if="message.file.type == 'application/pdf'" class="fas fa-file-pdf" style="font-size: 3em; cursor: pointer;" @click="viewFile(message.file)"></i>
              <i v-if="message.file.type == 'prescription'" class="fas fa-file-prescription" style="font-size: 3em; cursor: pointer;" @click="viewFile(message.file)"></i>
            </div>
            <div class="sc-message--file-name" style="display: inline; padding-left: 5px; padding-right: 5px;">
              <a v-if="message.file.type == 'application/pdf'" @click.prevent="viewFile(message.file)" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
              <a v-if="message.file.type == 'prescription'" @click.prevent="viewFile(message.file)" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
            </div>
            <div v-if="message.text" class="sc-message--file-text" style="padding: 1em 0 0 0">
              {{ message.text }}
              <span v-if="message.meta">
                <small style="font-size: 60%; font-weight: 200; font-style: italic;">
                  {{ message.meta }}
                </small>
              </span>
            </div>
            <div v-else class="sc-message--file-text-meta" style="padding: 1em 0 0 0">
              <span v-if="message.meta">
                <small style="font-size: 60%; font-weight: 200; font-style: italic;">
                  {{ message.meta }}
                </small>
              </span>
            </div>
          </div>

          <div v-if="message.file.type.includes('image/') || message.file.type.includes('video/')">
            <div class="sc-message--file-icon">
              <dynamic-image v-if="message.file.type.includes('image/')" :file-id="message.file.url" class="sc-image" @click.native="showPreview(message.file)" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;" />
              <dynamic-video v-if="message.file.type.includes('video/')" :file-id="message.file.url" class="sc-video" controlsList="nodownload" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;" :options="{ controls: true }" />
            </div>
            <div class="sc-message--file-name" style="display: flex; padding: 1em; background-color: #00000036 !important; border-bottom-left-radius: 3px; border-bottom-right-radius: 3px;">
              <a v-if="message.file.type.includes('image/')" style="flex: 2; display: grid; justify-items: left; align-items: center;" @click.prevent="showPreview(message.file)" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
              <a v-else style="flex: 2; display: grid; justify-items: left; align-items: center;" @click.prevent="" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
              <i class="fas fa-arrow-down" style="cursor: pointer; font-size: 3em; margin-left: auto;" @click="viewFile(message.file)"></i>
            </div>
            <div v-if="message.text" class="sc-message--file-text">
              {{ message.text }}
              <p v-if="message.meta" style="text-align: right; font-size: xx-small; margin-bottom: -1em;">
                {{ message.meta }}
              </p>
            </div>
            <div v-else class="sc-message--file-text">
              <p v-if="message.meta" style="text-align: right; font-size: xx-small; margin-bottom: -1em;">
                {{ message.meta }}
              </p>
            </div>
          </div>
        </template>

        <!-- Send file preview -->
        <template v-slot:file-preview="{ file }">
          <i v-if="file.type == 'application/pdf'" class="fas fa-file-pdf" id="preview-pdf" />
          <img v-if="file.type.includes('image/')" class="rounded mx-auto d-block" id="preview-img" :src="getFileSrc(file)" />
          <video v-if="file.type.includes('video/')" class="rounded mx-auto d-block" id="preview-video" :src="getFileSrc(file)"></video>
        </template>

      </beautiful-chat>

      <div v-if="showPreviewModal" style="position: absolute;
                                                        top: 0px;
                                                        left: 0px;
                                                        width: 100%;
                                                        margin-top: 4em;
                                                        background: rgba(128, 128, 128, 0.83);
                                                        z-index: 1;
                                                        height: calc(100vh - 56px);
                                                        display: flex;
                                                        justify-content: center;
                                                        align-items: center;">

        <dynamic-image v-if="previewFile.type.includes('image/')" :file-id="previewFile.url" class="sc-image" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; max-width:100%; max-height: 100vh;" />

        <div style="position: absolute; top: 1em; inset-inline-end: 1em; background: #00000070; padding: 1em; border-radius: 3px;">
          <i class="fas fa-arrow-down" style="cursor: pointer; color: white; font-size: 2em; margin-right: 1em;" @click="viewFile(previewFile)"></i>
          <i class="fas fa-times" @click="showPreviewModal = false" style="cursor: pointer; color: white; font-size: 2em;"></i>
        </div>

      </div>
    </tab-pane>

    <!-- File Share -->
    <tab-pane label="file-share">
      <template slot="label">
        <i class="fa fa-file" @click="$refs['file-share-alert'].$el.style.display = 'none'" />
        <badge type="info" style="position: absolute; top: 10px; display: none" ref="file-share-alert">
          <i class="fa fa-info" style="line-height: inherit; font-size: inherit"></i>
        </badge>
      </template>
      <div class="col-12" style="height: 80vh; overflow: auto">
        <div class="col-12 mt-5 text-center" v-if="!files || files.length < 1">
          {{ $t("message.No files shared yet") }}
        </div>
        <div class="col-12 file-list" v-for="(file, index) in files" :key="index">
          <div>
            <div class="col-12">
              <div class="row">
                <div class="col-2 col-md-2 col-lg-2" @click="viewFile(file)">
                  <div v-if="file.type.indexOf('image') > -1">
                    <dynamic-image :file-id="file.fileId" image-style="min-height: 20px; width: 100%">
                    </dynamic-image>
                  </div>
                  <div v-else-if="file.type.indexOf('pdf') > -1" style="text-align: center; font-size: xx-large;">
                    <i class="fa fa-file-pdf" style="font-size: 2em; color: #208fdc"></i>
                  </div>
                  <div v-else-if="file.type.indexOf('video') > -1" style="text-align: center; font-size: xx-large;">
                    <i class="fa fa-file-video" style="font-size: 2em; color: #208fdc"></i>
                  </div>
                  <div v-else-if="file.type.indexOf('audio') > -1" style="text-align: center; font-size: xx-large;">
                    <i class="fa fa-file-audio" style="font-size: 2em; color: #208fdc"></i>
                  </div>
                  <div v-else style="text-align: center; font-size: xx-large;">
                    <i class="fa fa-file" style="font-size: 2em; color: #208fdc"></i>
                  </div>
                </div>
                <div class="col-8 col-md-8 col-lg-8" @click="viewFile(file)">
                  <p class="card-heading file-name">{{ file.name }}</p>
                  <p class="card-heading file-date">
                    {{ getFormattedDate(file.created) }}
                  </p>
                </div>
                <div class="col-2 col-md-2 col-lg-2" style="color: red" @click="deleteFile(file, index)">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <infinite-loading spinner="waveDots" @infinite="getFiles" :identifier="activeTab">
          <span slot="no-more">{{ $t("message.No more files") }}</span>
          <span slot="no-results"></span>
        </infinite-loading>
      </div>
    </tab-pane>

    <!-- Prescription -->
    <tab-pane label="prescription">
      <template slot="label">
        <i class="fa fa-file-prescription" />
      </template>
      <div class="row" v-loading="DOWNLOADING_PRESCRIPTION" :element-loading-text="$t('message.Getting your prescription')" style="height: 100%; overflow: scroll">
        <!--Diagnostic summary -->
        <div class="col-12 mb-2" v-if="appointment && appointment.vitals && HAS_VITALS">
          <div class="row">
            <div class="col-12">
              <div class="col-12">
                <h5>{{ $t("message.Diagnostic Summary") }}</h5>
              </div>
              <div class="col-12" style="margin-top: 1em">
                <div class="col-12">
                  <div class="row">
                    <div class="col-4">
                      <div class="row" v-for="(vital, vitalName) in appointment.vitals" :key="vital.identifier" v-hide="vital.value == '' || vital.value == '--'" style="border-right: 1px solid #eee">
                        <div v-if="vitalName.toLowerCase() != 'ecg' &&
                          vital.value
                        " class="col-12">
                          <span>{{ vital.display }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-8">
                      <div class="row" v-for="(vital, vitalName) in appointment.vitals" :key="vital.identifier" v-hide="vital.value == '' || vital.value == '--'" style="border-right: 1px solid #eee">
                        <div v-if="vitalName.toLowerCase() != 'ecg' &&
                          vital.value
                        " class="col-12">
                          <div>
                            <span class="value ng-binding ng-scope">{{
                              vital.value
                            }}</span>&nbsp;
                            <span>{{ vital.unit }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Prescriptions -->
        <div class="col-12" style="padding-bottom: 5em;">
          <prescription :prescription="prescription.prescriptions" :appointment="appointment" :editable="false"></prescription>
          <n-button type="primary" round @click.native="downloadPrescription(prescription.prescriptions, prescription.created)" v-if="HAS_PRESCRIPTION_FOR_APPOINTMENT" class="download-pres-button">
            <i class="fa fa-print"></i>
            {{ $t("message.Download Prescription") }}
          </n-button>
        </div>
      </div>
    </tab-pane>

    <!-- View file modal-->
    <modal :show.sync="fileToView" headerClasses="d-none" class="view-file-modal" footerClasses="d-none" modalContentClasses="write-post-modal-content" :showClose="false" :animationDuration="250">

      <div class="view-file-header " v-show="showOptions">
        <i class="now-ui-icons ui-1_simple-remove close-icon" @click="closeModal"></i>
      </div>

      <div v-if="fileToView" class="file-wrapper" @click="showOptions = !showOptions">
        <dynamic-image v-if="fileToView.type.indexOf('image') > -1" :file-id="fileToView.fileId" image-id="signature-img" image-style="max-height: 100%;"></dynamic-image>

        <iframe v-if="fileToView.type.indexOf('application/pdf') > -1" :src="baseUrl + '/file/' + fileToView.fileId" style="height: 80%; width: 80%;"></iframe>

        <dynamic-video v-if="fileToView.type.includes('video/')" :file-id="fileToView.fileId" controlsList="nodownload" :options="{ controls: true }" />
      </div>

    </modal>

  </tabs>
</template>

<script>
/* eslint-disable no-undef */
import moment from "moment";

import { TabPane, Tabs } from "src/components";
import vitalCard from "@/pages/carenation/components/VitalCard";
import PrescriptionService from "../../../services/prescription.js";

import VitalsNotConfiguredSvg from "../components/svg_images/VitalsNotConfiguredSvg.vue";

export default {
  name: "telemed",

  components: {
    TabPane,
    Tabs,
    vitalCard,
    VitalsNotConfiguredSvg,
  },

  data() {
    return {
      files: [],
      simpleMeetingsQuery: null,
      prescription: {
        prescriptions: {
          descriptiveNotes: null,
          provisionalDiagnosis: {
            notes: null,
            icdCodes: [],
          },
          rx: [],
          labPrescription: [],
        },
      },
      filesPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      historicFilesPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      patient: null,
      vitals: {
        deviceData: {},
      },
      historicVitals: null,
      historicFiles: [],
      historicFilesPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      historicPrescriptions: [],
      selectedPrescription: null,
      FETCHED_HISTROIC_VITALS: false,
      loader: null,
      deviceProfile: [],
      errorMessages: {},
      DOWNLOADING_PRESCRIPTION: false,
      participants: [],
      carenationBotImage: "",
      defaultImage: "",
      previewFile: null,
      showPreviewModal: false,
      newMessagesCount: 0,
      isChatOpen: false,
      colors: {
        header: {
          bg: "var(--color-primary)",
          text: "#ffffff",
        },
        launcher: {
          bg: "#4e8cff",
        },
        messageList: {
          bg: "#ffffff",
        },
        sentMessage: {
          bg: "var(--color-primary)",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      },
      appointmentMessages: [],
      provider: null,
      doctorDisplayPic: null,
      nurseDisplayPic: null,
      nurse: null,
      IS_NURSE: false,
      IS_CARECO: false,
      titleImageUrl:
        "https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png",

      //File viewer
      fileToView: null,
      showOptions: true,
      activeTab: "",
    };
  },

  async mounted() {
    this.defaultImage = require("@/assets/img/proAvatar.png");
    this.carenationBotImage = require("@/assets/img/carenation-logo.png");
    this.IS_CARECO = this.user.roles.includes("careCoordinator");
    this.IS_NURSE = this.user.roles.includes("nurse");
    this.changeAppHeaderText("patient-history");

    //Get patient details
    try {
      this.patient = await this.$store.dispatch(
        "getPatientByPatientId",
        this.appointment.patient.patientId
      );
    } catch (e) {
      console.log(e);
    }

    //Get files history
    this.getFilesHistory();
    //Get prescription history
    try {
      this.historicPrescriptions = (
        await this.$store.dispatch("getPrescriptionsHistory", {
          patientId: this.appointment.patient.patientId,
        })
      ).data;
    } catch (e) {
      console.log(e);
    }

    //Get prescriptions
    let prescriptions = await this.$store.dispatch(
      "getPrescriptions",
      this.appointment._id
    );

    if (prescriptions && prescriptions.length > 0) {
      this.prescription = prescriptions[0];
    }

    try {
      let patientEp = null;
      for (let ep of this.patient.endpoints) {
        if (ep.isDefault && ep.name) {
          patientEp = ep.name;
          break;
        }
      }
      this.endpoint = await this.$store.dispatch("getEndpoint", patientEp);

      //get device profile from configurations
      let response = await this.$store.dispatch(
        "getConfigurationByEndpointId",
        {
          endpointId: this.endpoint._id,
          type: "deviceProfile",
        }
      );
      if (response && response.value) {
        this.deviceProfile = response.value;
      }
    } catch (e) {
      console.log(e);
    }
    //Get Appointment messages
    if (this.appointment) {
      let response = await this.$store.dispatch(
        "getAppointmentMessages",
        this.appointment._id
      );
      this.appointmentMessages = response;
    }
    /*     if (this.appointment.consultationType == "telemed-direct") {
      this.participants.push({
        id: this.appointment.patient.patientId,
        name:
          this.appointment.patient.firstName +
          " " +
          this.appointment.patient.lastName,
        imageUrl: require("@/assets/img/proAvatar.png"),
      });
      if (this.settings.brandLogoMini) {
        this.carenationBotImage = `${this.$store.state.baseUrl}/file/${this.settings.brandLogoMini}`;
      }
      this.participants.push({
        id: "carenation-bot",
        name: "Carenation bot",
        imageUrl: this.carenationBotImage,
      });
    } */
    /*     if (this.appointment.consultationType == "telemed-direct") {
      this.participants.push({
        id: this.appointment.patient.patientId,
        name:
          this.appointment.patient.firstName +
          " " +
          this.appointment.patient.lastName,
        imageUrl: require("@/assets/img/proAvatar.png"),
      });
    }
    this.participants.push({
      id: "carenation-bot",
      name: "Carenation bot",
      imageUrl: this.carenationBotImage,
    });
    this.doctorDisplayPic = require("@/assets/img/proAvatar.png");
    try {
      this.provider = await this.$store.dispatch(
        "getUserById",
        this.appointment.provider.providerId
      );
      if (this.provider.profileImage) {
        this.doctorDisplayPic = `${this.$store.state.baseUrl}/file/${this.provider.profileImage}`;
      }
      this.participants.push({
        id: this.appointment.provider.username,
        name:
          this.appointment.provider.firstName +
          " " +
          this.appointment.provider.lastName,
        imageUrl: this.doctorDisplayPic,
      });
    } catch (e) {
      console.log(e);
    }
    for (let associate of this.provider.associations) {
      if (associate.associationType == "assistant") {
        this.participants.push({
          id: associate.associatedUserUserName,
          name: associate.associatedUserFullName,
          imageUrl: associate.associatedUserProfileImage
            ? `${this.$store.state.baseUrl}/file/${associate.associatedUserProfileImage}`
            : require("@/assets/img/proAvatar.png"),
        });
      }
    }
    if (this.appointment.user && this.appointment.createdBy == "nurse") {
      try {
        this.nurseDisplayPic = require("@/assets/img/proAvatar.png");
        this.nurse = await this.$store.dispatch(
          "getUserById",
          this.appointment.user
        );
        if (this.nurse.profileImage) {
          this.nurseDisplayPic = `${this.$store.state.baseUrl}/file/${this.nurse.profileImage}`;
        }
        if (this.nurse) {
          this.participants.push({
            id: this.nurse.username,
            name: this.nurse.firstName + " " + this.nurse.lastName,
            imageUrl: this.nurseDisplayPic,
          });
        }
      } catch (e) {
        console.log(e);
      }
    } */
    if (this.appointment.consultationType == "telemed-direct") {
      this.participants.push({
        id: this.appointment.patient.patientId,
        name:
          this.appointment.patient.firstName +
          " " +
          this.appointment.patient.lastName,
        imageUrl: require("@/assets/img/proAvatar.png"),
      });
    }
    if (this.settings.brandLogoMini) {
      this.carenationBotImage = `${this.$store.state.baseUrl}/file/${this.settings.brandLogoMini}`;
    }
    this.participants.push({
      id: "carenation-bot",
      name: "Carenation bot",
      imageUrl: this.carenationBotImage,
    });

    if (this.IS_CARECO || this.IS_NURSE) {
      this.doctorDisplayPic = require("@/assets/img/proAvatar.png");
      try {
        this.provider = await this.$store.dispatch(
          "getUserById",
          this.appointment.provider.providerId
        );
        if (this.provider.profileImage) {
          this.doctorDisplayPic = `${this.$store.state.baseUrl}/file/${this.provider.profileImage}`;
        }
        this.participants.push({
          id: this.appointment.provider.username,
          name:
            this.appointment.provider.firstName +
            " " +
            this.appointment.provider.lastName,
          imageUrl: this.doctorDisplayPic,
        });
      } catch (e) {
        console.log(e);
      }
      for (let associate of this.provider.associations) {
        if (associate.associationType == "assistant") {
          if (associate.associatedUser != this.user._id) {
            this.participants.push({
              id: associate.associatedUserUserName,
              name: associate.associatedUserFullName,
              imageUrl: associate.associatedUserProfileImage
                ? `${this.$store.state.baseUrl}/file/${associate.associatedUserProfileImage}`
                : require("@/assets/img/proAvatar.png"),
            });
          }
        }
      }
    } else {
      if (this.appointment.user && this.appointment.createdBy == "nurse") {
        try {
          this.nurseDisplayPic = require("@/assets/img/proAvatar.png");
          this.nurse = await this.$store.dispatch(
            "getUserById",
            this.appointment.user
          );
          if (this.nurse.profileImage) {
            this.nurseDisplayPic = `${this.$store.state.baseUrl}/file/${this.nurse.profileImage}`;
          }
          if (this.nurse) {
            this.participants.push({
              id: this.nurse.username,
              name: this.nurse.firstName + " " + this.nurse.lastName,
              imageUrl: this.nurseDisplayPic,
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
      for (let associate of this.user.associations) {
        if (associate.associationType == "assistant") {
          this.participants.push({
            id: associate.associatedUserUserName,
            name: associate.associatedUserFullName,
            imageUrl: associate.associatedUserProfileImage
              ? `${this.$store.state.baseUrl}/file/${associate.associatedUserProfileImage}`
              : require("@/assets/img/proAvatar.png"),
          });
        }
      }
    }
    console.log("participatns--", this.participants);
  },

  computed: {
    appointment() {
      return this.$store.state.appointment;
    },
    settings() {
      return this.$store.state.settings;
    },
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    messageList() {
      /*       let messageList = [];
      if (
        this.appointment &&
        this.appointmentMessages &&
        this.appointmentMessages.length > 0
      ) {
        for (const msg of this.appointmentMessages) {
          if (!msg.hideForDoctor) {
            if (msg.type == "text") {
              let newMessage = {
                author:
                  msg.username == this.appointment.provider.username
                    ? "me"
                    : msg.username,
                data: { text: msg.content, meta: msg.time },
                type: msg.type,
              };
              messageList.push(newMessage);
            } else if (msg.type == "file") {
              let newMessage = {
                author:
                  msg.username == this.appointment.provider.username
                    ? "me"
                    : msg.username,
                data: {
                  file: {
                    name: msg.content,
                    url: msg.fileId,
                    type: msg.fileType,
                  },
                  meta: msg.time,
                  text: msg.text,
                },
                type: msg.type,
              };
              messageList.push(newMessage);
            } else if (msg.type == "call" && msg.content) {
              let newMessage = {
                author:
                  msg.username == this.appointment.provider.username
                    ? "me"
                    : msg.username,
                data: { text: msg.status, meta: { time: msg.time } },
                type: "system",
              };
              if (
                msg.username == this.appointment.provider.username &&
                (msg.status == "initiated" ||
                  msg.status == "accepted" ||
                  msg.status == "ended" ||
                  msg.status == "missed")
              ) {
                newMessage.data.meta.icon = "fas fa-arrow-up";
              } else if (
                msg.username != this.appointment.provider.username &&
                (msg.status == "initiated" ||
                  msg.status == "accepted" ||
                  msg.status == "ended" ||
                  msg.status == "missed")
              ) {
                newMessage.data.meta.icon = "fas fa-arrow-down";
              } else if (msg.status == "declined") {
                newMessage.data.meta.icon = "fas fa-video-slash";
              } else if (msg.status == "cancelled") {
                newMessage.data.meta.icon = "fas fa-video-slash";
              }
              if (msg.status == "missed") {
                newMessage.data.text = `Missed call ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "declined") {
                newMessage.data.text = `Call declined ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "cancelled") {
                newMessage.data.text = `Call cancelled ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "initiated") {
                newMessage.data.text = `Call initiated ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "accepted") {
                newMessage.data.text = `Call accepted ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "ended") {
                newMessage.data.text = `Call ended ${msg.firstName} ${msg.lastName}`;
              }
              messageList.push(newMessage);
            } else if (msg.type == "emoji") {
              let newMessage = {
                author:
                  msg.username == this.appointment.provider.username
                    ? "me"
                    : msg.username,
                data: { emoji: msg.content, meta: msg.time },
                type: msg.type,
              };
              messageList.push(newMessage);
            } else if (msg.type == "audio call" && msg.content) {
              let newMessage = {
                author:
                  msg.username == this.appointment.provider.username
                    ? "me"
                    : msg.username,
                data: {
                  text: msg.status,
                  meta: { time: msg.time, icon: "fas fa-phone-alt" },
                },
                type: "system",
              };
              if (msg.status == "audio call initiated") {
                newMessage.data.text = `Call initiated ${msg.firstName} ${msg.lastName}`;
              }
              messageList.push(newMessage);
            } else if (msg.patientExitMessage) {
              let newMessage = {
                author: msg.username,
                data: { text: msg.content, meta: msg.time },
                type: msg.type,
              };
              messageList.push(newMessage);
            }
          }
        }
      }
      return messageList; */
      let messageList = [];
      if (this.appointmentMessages.length > 0) {
        for (const msg of this.appointmentMessages) {
          if (!msg.hideForDoctor) {
            if (msg.type == "text") {
              let newMessage = {
                author:
                  msg.username == this.user.username ? "me" : msg.username,
                data: { text: msg.content, meta: msg.time },
                type: msg.type,
              };
              if (msg.name != "Carenation bot") {
                newMessage["fullName"] = msg.name;
              }
              messageList.push(newMessage);
            } else if (msg.type == "file") {
              let newMessage = {
                author:
                  msg.username == this.user.username ? "me" : msg.username,
                data: {
                  file: {
                    name: msg.content,
                    url: msg.fileId,
                    type: msg.fileType,
                  },
                  meta: msg.time,
                  text: msg.text,
                },
                type: msg.type,
              };
              if (msg.name != "Carenation bot") {
                newMessage.data["fullName"] = msg.name;
              }
              messageList.push(newMessage);
            } else if (msg.type == "call" && msg.content) {
              let newMessage = {
                author:
                  msg.username == this.user.username ? "me" : msg.username,
                data: { text: msg.status, meta: { time: msg.time } },
                type: "system",
              };
              if (
                msg.username == this.user.username &&
                (msg.status == "initiated" ||
                  msg.status == "accepted" ||
                  msg.status == "ended" ||
                  msg.status == "missed")
              ) {
                newMessage.data.meta.icon = "fas fa-arrow-up";
              } else if (
                msg.username != this.user.username &&
                (msg.status == "initiated" ||
                  msg.status == "accepted" ||
                  msg.status == "ended" ||
                  msg.status == "missed")
              ) {
                newMessage.data.meta.icon = "fas fa-arrow-down";
              } else if (msg.status == "declined") {
                newMessage.data.meta.icon = "fas fa-video-slash";
              } else if (msg.status == "cancelled") {
                newMessage.data.meta.icon = "fas fa-video-slash";
              }
              if (msg.status == "missed") {
                newMessage.data.text = `Missed call ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "declined") {
                newMessage.data.text = `Call declined ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "cancelled") {
                newMessage.data.text = `Call cancelled ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "initiated") {
                newMessage.data.text = `Call initiated ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "accepted") {
                newMessage.data.text = `Call accepted ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "ended") {
                newMessage.data.text = `Call ended ${msg.firstName} ${msg.lastName}`;
              }
              messageList.push(newMessage);
            } else if (msg.type == "emoji") {
              let newMessage = {
                author:
                  msg.username == this.user.username ? "me" : msg.username,
                data: { emoji: msg.content, meta: msg.time },
                type: msg.type,
              };
              messageList.push(newMessage);
            } else if (msg.type == "audio call" && msg.content) {
              let newMessage = {
                author:
                  msg.username == this.user.username ? "me" : msg.username,
                data: {
                  text: msg.status,
                  meta: { time: msg.time, icon: "fas fa-phone-alt" },
                },
                type: "system",
              };
              if (msg.status == "audio call initiated") {
                newMessage.data.text = `Call initiated ${msg.firstName} ${msg.lastName}`;
              }
              messageList.push(newMessage);
            } else if (msg.patientExitMessage) {
              let newMessage = {
                author: msg.username,
                data: { text: msg.content, meta: msg.time },
                type: msg.type,
              };
              messageList.push(newMessage);
            } else if (
              msg.doctorJoinedMessage ||
              msg.doctorExitedMessage ||
              msg.prescriptionSharedMessage
            ) {
              if (this.IS_CARECO || this.IS_NURSE) {
                let newMessage = {
                  author: msg.username,
                  data: { text: msg.content, meta: msg.time },
                  type: msg.type,
                };
                messageList.push(newMessage);
              }
            } else if (
              (msg.carecoJoinedMessage || msg.carecoExitedMessage) &&
              this.IS_NURSE
            ) {
              let newMessage = {
                author: msg.username,
                data: { text: msg.content, meta: msg.time },
                type: msg.type,
              };
              messageList.push(newMessage);
            }
          }
        }
      }
      return messageList;
    },
    HAS_VITALS() {
      let HAS_VITALS = false;
      if (this.appointment) {
        //Check for empty vitals
        for (var vital in this.appointment.vitals) {
          if (
            this.appointment.vitals[vital].value == "--" ||
            this.appointment.vitals[vital].value == ""
          ) {
            HAS_VITALS = false;
          } else {
            HAS_VITALS = true;
            break;
          }
        }
      }
      return HAS_VITALS;
    },
    previewLink() {
      return this.baseUrl + "/file/";
    },
    HAS_PRESCRIPTION() {
      let prescriptions =
        this.selectedPrescription.prescriptions[0].prescriptions;
      return PrescriptionService.hasPrescription(prescriptions);
    },
    HAS_PRESCRIPTION_FOR_APPOINTMENT() {
      let prescriptions = this.prescription.prescriptions;
      return PrescriptionService.hasPrescription(prescriptions);
    },
  },

  methods: {
    patientHistoryTabChange(label) {
      this.activeTab = label;
    },
    onTabChange(label) {
      this.changeAppHeaderText(label);
      this.activeTab = label;
    },
    //Appointment Files
    async getFiles($state) {
      if (!$state) {
        this.files = [];
        this.filesPagination = {
          pageNumber: 1,
          totalPages: 0,
        };
      }
      var query = {
        appointmentId: this.appointment._id,
      };
      let response = await this.$store.dispatch("getFiles", {
        query,
        pageNumber: this.filesPagination.pageNumber,
        pageSize: screen.height < 721 ? "7" : "15",
      });
      if (response.data && response.data.length > 0) {
        this.files.push(...response.data);
        this.filesPagination.totalPages = response.totalPages;
        this.filesPagination.pageNumber += 1;
        $state && $state.loaded();
      } else {
        $state && $state.complete();
      }
    },
    //Files History
    async getFilesHistory($state) {
      try {
        let response = await this.$store.dispatch("getFiles", {
          query: {
            patientId: this.patient.patientId,
          },
          pageNumber: this.historicFilesPagination.pageNumber,
          pageSize: 10,
        });
        if (response.data && response.data.length) {
          this.historicFiles.push(...response.data);
          this.filesTotalPages = response.totalPages;
          this.historicFilesPagination.pageNumber += 1;
          $state && $state.loaded();
        } else {
          $state && $state.complete();
        }
      } catch (e) {
        console.log(e);
      }
    },
    openChat() {
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    getAgeYears(date) {
      var m = moment(date);
      var years = moment().diff(m, "years", false);
      return years + " " + this.$t("message.Years");
    },
    closeChat() {
      this.isChatOpen = false;
    },
    showPreview(file) {
      this.previewFile = file;
      this.showPreviewModal = true;
    },
    onMessageWasSent(message) { },
    async viewFile(file) {
      let that = this;
      try {
        that.loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        //get file from server
        let fileArrayBuffer = await this.$store.dispatch(
          "getFile",
          file.fileId || file.url
        );

        let pdfBlob = new Blob([fileArrayBuffer]);

        let storageLocation = "";

        if (typeof device !== "undefined") {
          switch (device.platform) {
            case "Android":
              storageLocation = cordova.file.externalDataDirectory;
              break;

            case "iOS":
              storageLocation = cordova.file.documentsDirectory;
              break;
          }

          let folderPath = storageLocation;

          window.resolveLocalFileSystemURL(
            folderPath,
            function (dir) {
              dir.getFile(
                file.name,
                {
                  create: true,
                },
                function (file) {
                  file.createWriter(
                    function (fileWriter) {
                      fileWriter.write(pdfBlob);

                      fileWriter.onwriteend = function () {
                        var url = file.nativeURL;
                        cordova.plugins.fileOpener2.open(url, pdfBlob.type, {
                          error: function error(err) {
                            console.error(err);
                            that.loader.hide();
                            alert(this.$t("message.Unable to download"));
                          },
                          success: function success() {
                            that.loader.hide();
                            console.log("success with opening the file");
                          },
                        });
                      };

                      fileWriter.onerror = function (err) {
                        that.loader.hide();
                        alert(this.$t("message.Unable to download"));
                        console.error(err);
                      };
                    },
                    function (err) {
                      that.loader.hide();
                      // failed
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  that.loader.hide();
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            },
            function (err) {
              that.loader.hide();
              alert(this.$t("message.Unable to download"));
              console.error(err);
            }
          );
        }
      } catch (e) {
        that.loader.hide();
        console.log(e);
      }
    },

    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },
    async deleteFile(file, index) {
      let _this = this;
      swal
        .fire({
          title: _this.$t("message.Delete File?"),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: _this.$t("message.Yes"),
          cancelButtonText: _this.$t("message.No"),
          closeOnConfirm: true,
        })
        .then(async (confirm) => {
          if (confirm.value) {
            _this.loader = _this.$loading.show({
              // Optional parameters
              container: null,
              canCancel: false,
            });
            try {
              await _this.$store.dispatch("deleteFile", file);
              this.files.splice(index, 1);
              _this.loader.hide();
              swal.fire({
                title: _this.$t("message.Success!"),
                text: _this.$t("message.File deleted successfully"),
                type: "success",
                timer: 3000,
              });
            } catch (err) {
              _this.loader.hide();
              swal.fire({
                title: _this.$t("message.Ooops!"),
                text: _this.$t("message.Error while deleting file"),
                type: "error",
                timer: 5000,
              });
            }
          } else {
            swal.close();
          }
        });
    },

    //Patient history
    viewPrescription(prescription) {
      // route to prescription page
      this.$router.push(
        "viewhistoricprescription/" + prescription.prescriptions[0]._id
      );
    },
    async getVitalHistory() {
      if (!this.FETCHED_HISTROIC_VITALS) {
        try {
          this.historicVitals = await this.$store.dispatch("getVitalHistory", {
            patientId: this.appointment.patient.patientId,
            deviceProfile: this.deviceProfile,
            fromTime: moment().subtract(30, "days").unix() * 1000,
            toTime: moment().unix() * 1000,
          });
          this.FETCHED_HISTROIC_VITALS = true;
        } catch (e) {
          console.log(e);
        }
      }
    },
    downloadPrescription(prescriptions, prescriptionDate) {
      let that = this;
      that.DOWNLOADING_PRESCRIPTION = true;
      if (window.cordova) {
        PrescriptionService.getDataURL(
          this.appointment,
          prescriptions,
          prescriptionDate,
          {},
          (dataUrl) => {
            // convert base64 to raw binary data held in a string
            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            var byteString = atob(dataUrl.split(",")[1]);

            // separate out the mime component
            var mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];

            // write the bytes of the string to an ArrayBuffer
            var ab = new ArrayBuffer(byteString.length);

            // create a view into the buffer
            var ia = new Uint8Array(ab);

            // set the bytes of the buffer to the correct values
            for (var i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }

            // write the ArrayBuffer to a blob, and you're done
            var pdfBlob = new Blob([ab], { type: mimeString });

            let storageLocation = "";

            if (typeof device !== "undefined") {
              switch (device.platform) {
                case "Android":
                  storageLocation = cordova.file.externalDataDirectory;
                  break;

                case "iOS":
                  storageLocation = cordova.file.documentsDirectory;
                  break;
              }

              let folderPath = storageLocation;

              window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                  dir.getFile(
                    "prescription",
                    {
                      create: true,
                    },
                    function (file) {
                      file.createWriter(
                        function (fileWriter) {
                          fileWriter.write(pdfBlob);

                          fileWriter.onwriteend = function () {
                            var url = file.nativeURL;
                            cordova.plugins.fileOpener2.open(
                              url,
                              pdfBlob.type,
                              {
                                error: function error(err) {
                                  console.error(err);
                                  that.DOWNLOADING_PRESCRIPTION = false;
                                  alert(this.$t("message.Unable to download"));
                                },
                                success: function success() {
                                  that.DOWNLOADING_PRESCRIPTION = false;
                                  console.log("success with opening the file");
                                },
                              }
                            );
                          };

                          fileWriter.onerror = function (err) {
                            that.DOWNLOADING_PRESCRIPTION = false;
                            alert(this.$t("message.Unable to download"));
                            console.error(err);
                          };
                        },
                        function (err) {
                          that.DOWNLOADING_PRESCRIPTION = false;
                          // failed
                          alert(this.$t("message.Unable to download"));
                          console.error(err);
                        }
                      );
                    },
                    function (err) {
                      that.DOWNLOADING_PRESCRIPTION = false;
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  that.DOWNLOADING_PRESCRIPTION = false;
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            }
          }
        );
      } else {
        PrescriptionService.download(
          this.appointment,
          prescriptions,
          prescriptionDate,
          {}, () => {
            that.DOWNLOADING_PRESCRIPTION = false;
          }
        );
      }
    },
    getFileSrc(file) {
      let fileSrc = URL.createObjectURL(file);
      return fileSrc;
    },
    messageAvatar(id) {
      for (let participant of this.participants) {
        if (participant.id == id) {
          return participant.imageUrl;
        }
      }
      return this.defaultImage;
    },

    viewFile(file) {
      this.fileToView = file;
      this.showOptions = true;
    },
    closeModal() {
      this.fileToView = null;
    },
  },
};
</script>

<style scoped>
/deep/.download-pres-button {
  left: 50%;
  transform: translateX(-50%);
  bottom: 6em;
  position: fixed;
}

[dir="rtl"] /deep/.download-pres-button {
  transform: translateX(50%);
}

/deep/ .patient-history-tabs .nav-pills .nav-item .nav-link {
  min-width: 75px !important;
}

/deep/ .nav-pills .nav-item .nav-link {
  min-width: 70px !important;
}

/deep/ .patient-history-tabs a.nav-link {
  font-size: 13px;
}

/deep/ .patient-history-tabs {
  height: 100%;
}

/deep/ .tab-content.patient-history-tab-content {
  height: calc(100% - 21px);
}

/deep/ .tab-content {
  /* handled at parent */
  height: 100%;
  /* height: calc(100% - 68px); */
}

.content > div {
  height: 100%;
}

.tab-pane.active {
  height: 100%;
  padding-top: 1em;
}

.prescription-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.prescription-list:first-child {
  border-top: none;
}

.prescription-list.selected {
  background-color: whitesmoke;
}

.prescription-icon {
  line-height: 3em;
  color: #2ca8ff;
  font-size: 1.5em;
}

.reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}

.file-name {
  font-size: 1em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ label {
  margin-bottom: 0;
}

#chat-message > div {
  height: 100%;
}

.ios #chat-message > div {
  height: 98%;
}

/deep/ .sc-chat-window {
  position: unset !important;
  padding-top: 2em !important;
  height: 100% !important;
  width: 100% !important;
  max-height: 100% !important;
}

/deep/ .sc-message--file {
  max-width: 35vh;
}

/deep/ .sc-message-list {
  height: 100% !important;
  background-image: url("../../../assets/img/background.png") !important;
  background-color: #212529 !important;
  padding-top: 0em !important;
  padding-bottom: 0em !important;
}

@media (max-width: 450px) {
  /deep/ .sc-message {
    width: 100% !important;
  }
}

/deep/ .sc-message:first-of-type {
  margin-top: 4em !important;
}

/deep/ .sc-user-input--button svg {
  height: 25px !important;
  width: 25px !important;
}

/deep/ .full-name {
  font-weight: 600;
  color: var(--color-primary);
}

/deep/.sc-message--file .full-name {
  margin-top: -0.7em;
  margin-bottom: 0.4em;
}

/deep/ .sent .full-name {
  display: none;
}

/deep/ .file-container {
  border-top-left-radius: 0px;
}

#preview-pdf {
  font-size: 7em;
  margin-top: 7%;
  text-align: center;
  width: 100%;
}

#preview-img {
  max-width: 100%;
  height: 15em;
  margin-top: 1em;
}

#preview-video {
  max-width: 100%;
  height: 15em;
  margin-top: 1em;
}

/deep/ .sc-message--system {
  opacity: 0.9 !important;
  color: #0d2747 !important;
  background-color: #f5f5f5 !important;
}

/deep/ .sc-message--system p {
  color: rgb(34, 34, 34) !important;
}

/deep/ label {
  margin-bottom: 0;
}

/deep/ .sc-message--content.received .sc-message--file i {
  color: rgb(134, 134, 134);
}

/deep/ .sc-image {
  max-height: 18em;
  max-width: 100%;
  min-width: 100%;
}

/deep/ .sc-video {
  max-width: 100%;
}

/deep/ .sc-user-input {
  background: #e6e6e6 !important;
  border-radius: 0px !important;
}

/deep/ .sc-user-input--text {
  color: rgb(86, 88, 103) !important;
  background-color: white !important;
  border-radius: 60px !important;
  margin-top: 0.5em !important;
  margin-bottom: 0.5em !important;
  padding-top: 0.5em !important;
  padding-bottom: 0.5em !important;
  line-height: 2 !important;
}

.chat-ended {
  position: absolute;
  bottom: 0px;
  display: flex;
  align-items: end;
  justify-content: center;
}

/deep/ .disable-input .sc-user-input {
  display: none !important;
}

/deep/.sc-user-input {
  display: none !important;
}

/deep/ .view-file-modal .modal-content .modal-body {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  height: 100%;
  padding-bottom: 0px;
}

/deep/ .view-file-modal .modal-dialog {
  margin: 0;
}

/deep/ .view-file-modal .modal-content {
  background-color: black;
  height: 100vh;
}

/deep/ .view-file-modal .file-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .view-file-modal .close-icon {
  font-weight: 900;
  font-size: 1.2em;
  color: #a5a5a5;
  padding: 1rem;
}

/deep/ .view-file-modal .view-file-header {
  position: absolute;
  z-index: 1;
  background: #343a4080;
  width: 100%;
}
</style>
